import React from 'react'
import { Table, TableBody, TableContainer, TableRow, Paper } from '@mui/material'
import TableCell from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&:nth-of-type(odd)`]: {
    fontSize: 14,
    backgroundColor: '#F5F5F5',
    width: '30%',
  },
  border: 0,
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:first-of-type td': {
    borderTopLeftRadius: '8px',
  },
  '&:last-child td': {
    borderBottomLeftRadius: '8px',
  },
}))

const TableConfirm = (props) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 250 }} aria-label="simple table">
        <TableBody>
          {props.data.map((row) => (
            <StyledTableRow key={row.label}>
              <StyledTableCell align="left">{row.label}</StyledTableCell>
              <StyledTableCell align="left">{row.value}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

TableConfirm.propTypes = {
  data: PropTypes.any,
}

export default TableConfirm
